import React from 'react';
import { isInternalUrl } from '@lib/urls';
import { Link } from 'gatsby';

export default function FrontpageLink({ key, css, url, text, className, ...props }) {

  return isInternalUrl(url) ?
    <Link
      key={key}
      css={css}
      to={url}
      className={className}
      {...props}
    >
      {text}
    </Link>
    :
    <a
      key={key}
      css={css}
      href={url}
      className={className}
      {...props}
    >
      {text}
    </a>;

}